import { useEffect, useState } from 'react';
import _ from 'lodash';
import { getPullRequestsSearchSummary } from 'common/services/pull-requests.service';
import { callBranchesCount } from 'common/services/branches.service';
import {
  overPrsThreshholdCheck,
  getNotificationThresholds,
  PRS_THRESHHOLD,
  notificationPredictionType,
  TWO_WEEKS_IN_DAYS,
  today,
  twoWeeksAgo
} from '../notifications.service';

export const useNotificationPrediction = ({
  selectedTeamId,
  notifications,
  NOTIFICATIONS_BUILDER,
  notificationThresholds = null,
  prMerged = []
}) => {
  const isOverPrsThreshhold = overPrsThreshholdCheck(prMerged, PRS_THRESHHOLD);

  const predictions = notifications.map(notification => {
    const _notificationThresholds =
      notificationThresholds || getNotificationThresholds(notification);

    const notificationKey = _.get(notification, 'notificationKey');

    const NOTIFICATION_PROPS = _.get(NOTIFICATIONS_BUILDER, notificationKey);

    if (!_.get(NOTIFICATION_PROPS, 'prediction')) return [];

    return NOTIFICATION_PROPS.prediction({
      ..._notificationThresholds,
      startDate: twoWeeksAgo,
      endDate: today
    });
  });

  const predictionsType = _.get(predictions, '[0][0].type');

  const filters = predictions.map(prediction => {
    return {
      ..._.get(prediction, '[0].filters', {}),
      team_ids: [selectedTeamId]
    };
  });

  // const [issuesCount, setIssuesCount] = useState(0);
  const [predictionsCount, setPredictionsCount] = useState([]);

  useEffect(() => {
    const getData = async () => {
      // if (_.get(predictions[0][0], 'shouldGetIssues')) {
      //   await getPredictionIssuesCount();
      // }
      if (isOverPrsThreshhold && selectedTeamId) {
        getPredictions();
      }
    };
    getData();
  }, [isOverPrsThreshhold]);

  const predictionsCountAvg = responses =>
    responses.map((response, index) => {
      const count = _.get(response, 'count', 0);
      const key = _.get(notifications, `[${index}].notificationKey`);
      return {
        count: count / TWO_WEEKS_IN_DAYS || 0,
        notificationKey: key
      };
    });

  const branchesCountReqBuilder = () => {
    return filters.map(item => {
      return { filter: item, point_in_time: today };
    });
  };

  const branchesResponseOrganizer = responses => {
    return responses.map(item => {
      return { count: item };
    });
  };

  const getPredictionsCountByType = async type => {
    switch (type) {
      case notificationPredictionType.BRANCHES:
        try {
          const responses =
            (await callBranchesCount(branchesCountReqBuilder())) || [];
          return predictionsCountAvg(branchesResponseOrganizer(responses));
        } catch (e) {
          return [0];
        }
      case notificationPredictionType.PRS:
        try {
          const responses = (await getPullRequestsSearchSummary(filters)) || [];
          return predictionsCountAvg(responses);
        } catch (e) {
          return [0];
        }
      //for TEAM_WIP
      // case notificationPredictionType.ISSUES:
      //   const avgIssuesCount = predictionCountAvg([issuesCount])[0];
      //   const _notification = _.get(notifications, '[0]');
      //   const tooManyCount = _.get(_notification, 'values.issues_count', 0);
      //   const predicted = avgIssuesCount - tooManyCount;
      //   const count = predicted > 0 ? predicted : 0;
      //   return count;
      default:
        return [0];
    }
  };

  const getPredictions = async () => {
    const count = await getPredictionsCountByType(predictionsType);
    setPredictionsCount(count);
  };

  // const getPredictionIssuesCount = async () => {
  //   const predictedIssues = await getPredictedIssuesCount(filters[0])[0];
  //   setIssuesCount(_.get(predictedIssues, 'count', 0) || 0);
  // };

  return {
    predictionsCount,
    getPredictions
  };
};
